import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=f04ddce8&scoped=true&"
import script from "./js/banner.js?vue&type=script&lang=js&"
export * from "./js/banner.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04ddce8",
  null
  
)

export default component.exports